/* eslint-disable handle-callback-err */
/**
 * WebSocket Module
 */

import apiEvent from '@/util/call/apiEvent'
import eventBus from '@/event_bus'
import Util from '@/util'
import axios from 'axios'
import callServer from '../call/callServer'
import util from '../../../util'

const getDefaultState = () => {
  return {
    telNumber: '',
    callLoginId: '',
    callBrandId: '',
    callAgentGroup: '',
    enabledCallAgent: false,
    isExistCallAgent: undefined,
    stompClient: null,
    isCallConnecting: false,
    isCallSocketConnected: false,
    isValidTel: false,
    isTelIng: false,
    isOverlap: false,
    stopCnt: 0,
    setIntervalObj: null,
    isIntervalCheck: false,
    isCallSocketReConnected: false,
    isFirstConnect: true,
    pingTryCount: 0,
    consultStatus: {
      totalTime: '00:00:00',
      averageTime: '00:00:00',
      waitTime: '00:00:00',
      summaryTime: '00:00:00',
      emptyTime: '00:00:00',
      maxCount: { inBound: 0, outBound: 0 },
      averageCount: { inBound: 0, outBound: 0 },
      myCount: { inBound: 0, outBound: 0 }
    }
  }
}
const state = getDefaultState()

const getters = {
  IS_CALL_CONNECTED: (state) => { return state.isCallSocketConnected },
  telNumber: (state) => { return state.telNumber },
  callLoginId: (state) => { return state.callLoginId },
  callBrandId: (state) => { return state.callBrandId },
  callAgentGroup: (state) => { return state.callAgentGroup },
  enabledCallAgent: (state) => { return state.enabledCallAgent },
  isExistCallAgent: (state) => { return state.isExistCallAgent },
  IS_VALID_TEL: (state) => { return state.isValidTel },
  IS_TEL_ING: (state) => { return state.isTelIng },
  IS_OVER_LAP: (state) => { return state.isOverlap },
  isAvailableCall: (state) => {
    return state.enabledCallAgent && state.isExistCallAgent && state.isValidTel && state.isTelIng
  },
  pingTryCount: (state) => { return state.pingTryCount },
  consultStatus: (state) => { return state.consultStatus }
}

const mutations = {
  START_CALL_CONNECT (state) {
    state.isCallConnecting = true
  },
  END_CALL_CONNECT (state) {
    state.isCallConnecting = false
    state.isCallSocketConnected = true
  },
  FAIL_CALL_CONNECT (state) {
    state.isCallConnecting = false
    state.isCallSocketConnected = false
  },
  OPEN_CALL (state) {
    apiEvent.startMonitor(state.telNumber)
  },
  LOGIN_CALL (state) {
    apiEvent.loginCall(state.callLoginId)
  },
  CLOSE_CALL (state, { isResetState } = { isResetState: true }) {
    if (!state.isCallSocketConnected) return
    state.pingTryCount = 0
    apiEvent.closeCall(state.callLoginId)
    if (callServer.state.callMode === 'KT') {
      clearInterval(state.setIntervalObj)
      if (isResetState) {
        Object.assign(state, getDefaultState())
      }
      if (state.stompClient) {
        state.stompClient.close()
      }
    }
  },
  RESET_CALL (state) {
    clearInterval(state.setIntervalObj)
    Object.assign(state, getDefaultState())
    if (state.stompClient) {
      state.stompClient.close()
    }
  },
  CLEAR_CALL_DETAILS () {
    apiEvent.removeLocalStorage()
  },
  sendMessageToCallSocket (state, payload) {
    if (state.stompClient.readyState === WebSocket.OPEN) {
      state.stompClient.send(payload)
    } else if (callServer.state.callMode !== 'KT') {
      eventBus.$emit('websocket-disconnect')
    }
  },
  changeIsExistCallAgent (state, isExistCallAgent) {
    state.isExistCallAgent = isExistCallAgent
  },
  changeIsValidTel (state, isValidTel) {
    state.isValidTel = isValidTel
  },
  changeTelNumber (state, telNumber) {
    state.telNumber = telNumber
  },
  changeEnabledCallAgent (state, useYn) {
    state.enabledCallAgent = useYn === 'Y'
  },
  changeIsTelIng (state, isTelIng) {
    state.isTelIng = isTelIng
  },
  changeIsIntervalCheck (state, isIntervalCheck) {
    state.isIntervalCheck = isIntervalCheck
  },
  changeIsCallConnecting (state, isCallConnecting) {
    state.isCallConnecting = isCallConnecting
  },
  increasePingTryCnt (state) {
    state.pingTryCount = ++state.pingTryCount
  },
  resetPingTryCnt (state) {
    state.pingTryCount = 0
  },
  CLEAR_INTERVAL (state) {
    if (state.setIntervalObj) {
      clearInterval(state.setIntervalObj)
      state.stopCnt = 0
      state.setIntervalObj = null
    }
  },
  SET_CONSULT_SATAUS (state, payload) {
    state.consultStatus = Object.assign(state.consultStatus, payload)
  }
}

const actions = {
  async call_connect ({commit, state}) {
    if (state.isCallSocketConnected || (state.isCallConnecting && !state.isCallSocketConnected) || !callServer.state.callWebsocketUrl) {
      return false
    }

    if (callServer.state.callMode !== 'KT') {
      if (!state.isFirstConnect) {
        callServer.mutations.changeCallWebSocketUrl(callServer.state)
        state.isCallSocketReConnected = true
      }
      state.isFirstConnect = false

      // FIXME: 필요해서 추가했는데, NEOMECCA 버전 영향도때문에 삭제해야 할수도
      if (!callServer.state.callWebsocketUrl) return

      commit('START_CALL_CONNECT')

      state.stompClient = new WebSocket(callServer.state.callWebsocketUrl)
      state.stompClient.binaryType = 'arraybuffer'

      clearInterval(state.setIntervalObj)
      state.setIntervalObj = setInterval(() => {
        if (state.isIntervalCheck) {
          if (state.stopCnt < 5) {
            state.stopCnt += 1
          } else {
            if (!state.isOverlap) {
              state.isOverlap = true
            }
            // FIXME: 추가된 값이라 삭제 함
            // clearInterval(state.setIntervalObj)
          }
        }
      }, 2500)

      state.stompClient.onopen = function (e) {
        commit('END_CALL_CONNECT')
        commit('OPEN_CALL')
      }

      state.stompClient.onmessage = function (e) {
        if (state.isOverlap) {
          state.isOverlap = false
        }

        if (state.isCallSocketReConnected) {
          state.isCallSocketConnected = true
          state.isCallSocketReConnected = false
          eventBus.$emit('change-call-display')
        }

        if (util.parseLoginToken() && util.parseLoginToken().callServerType && util.parseLoginToken().callServerType.indexOf('KT') > -1) {
          commit('CLEAR_INTERVAL')
        }
        state.stopCnt = 0
        const rcvData = new Uint8Array(e.data) // BINARY DATA BUFFER
        apiEvent.EventProc(rcvData) // SAVE EVENT STRUCT
      }

      state.stompClient.onclose = function (e) {
        commit('FAIL_CALL_CONNECT')
        eventBus.$emit('call-reconnect-start')
      }

      state.stompClient.onerror = function (e) {
        console.log(e)
      }
    } else {
      if (!state.enabledCallAgent && !state.isExistCallAgent) { return }
      if (!window.sessionStorage.getItem('isCall')) {
        if (!localStorage.getItem('call-info')) return
        const { startTime, endTime } = JSON.parse(localStorage.getItem('call-info'))
        if (startTime && !(startTime && endTime)) {
          state.isOverlap = true
          return
        }
      }
      state.isFirstConnect = false

      commit('START_CALL_CONNECT')

      state.stompClient = new WebSocket(callServer.state.callWebsocketUrl)
      state.stompClient.binaryType = 'arraybuffer'

      state.stompClient.onopen = function (e) {
        commit('END_CALL_CONNECT')
        commit('OPEN_CALL')
        commit('CLEAR_INTERVAL')
      }

      state.stompClient.onmessage = function (e) {
        commit('CLEAR_INTERVAL')
        if (state.isOverlap) {
          state.isOverlap = false
        }

        if (state.isCallSocketReConnected) {
          state.isCallSocketConnected = true
          state.isCallSocketReConnected = false
          eventBus.$emit('change-call-display')
        }

        const rcvData = JSON.parse(e.data)
        apiEvent.EventProc(rcvData) // SAVE EVENT STRUCT
      }

      state.stompClient.onclose = function (e) {
        commit('FAIL_CALL_CONNECT')
        eventBus.$emit('call-reconnect-start')
      }

      state.stompClient.onerror = function (e) {
        console.log(e)
      }
    }
  },
  setCallAgentInfo () {
    return new Promise((resolve) => {
      if (callServer.state.callMode !== 'KT' && !callServer.state.callApiUrl) return
      if (!Util.parseLoginToken()) return

      if (util.parseLoginToken().callServerType && util.parseLoginToken().callServerType.indexOf('KT') > -1) {
        callServer.mutations.setCallMode(callServer.state, 'KT')
      }

      if (callServer.state.callMode !== 'KT') {
        axios({
          method: 'get',
          url: '/gateway/call/agent',
          params: {
            externalId: Util.parseLoginToken().loginId
          },
          headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then((res) => {
          if (res.data.code === 0) {
            const data = res.data.data
            if (Object.keys(data).length > 0 && data.extensionNumber) {
              state.isExistCallAgent = true
              state.telNumber = data.extensionNumber
              state.callLoginId = data.userId
              state.callBrandId = data.agentGroupCd
              state.callAgentGroup = data.agentCd
              state.enabledCallAgent = data.useYn === 'Y'
            } else {
              state.enabledCallAgent = false
              state.isExistCallAgent = false
            }
            eventBus.$emit('set-call-agent')
            resolve(state)
          }
        })
      } else {
        const { agentId, loginId } = Util.parseLoginToken()
        state.callLoginId = loginId
        axios({
          method: 'get',
          url: `/api/agent/${agentId}/call/info`,
          headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then((res) => {
          if (res.data.code === 0) {
            const data = res.data.data
            if (Object.keys(data).length > 0 && data.extensionNumber) {
              const { callWebsocketUrl } = callServer.state
              if (callWebsocketUrl.indexOf('agent_id') < 0) {
                callServer.state.callWebsocketUrl = `${callWebsocketUrl}/ws/?agent_id=${data.extensionNumber}`
              }
              state.isExistCallAgent = true
              state.telNumber = data.extensionNumber
              state.enabledCallAgent = data.approvalStatus === 'ENABLE'
            } else {
              state.enabledCallAgent = false
              state.isExistCallAgent = false
            }
            eventBus.$emit('set-call-agent')
            resolve(state)
          }
        })
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/callWebsocket/index.js